<script>
  // core components
</script>

<!-- Header -->
<div class="relative bg-blueGray-800 md:pt-16 pb-32 pt-12">
  <div class="px-4 md:px-10 mx-auto w-full">
    <div>
    </div>
  </div>
</div>
